export default __webpack_public_path__ + "static/lineto-circular-bold-c-a8f7ebfe4d408d6aa8783af8b19ac535.woff";